import React from 'react';
import DropdownItem from 'react-bootstrap/DropdownItem';
import { LinkContainer } from 'react-router-bootstrap';
import withSounds from 'containers/withSounds';
import HeaderAdminLink from '../HeaderAdminLink';
import './MainMenuItems.css';

const MenuItemWithSounds = withSounds({ mouseEnterSound: true })(DropdownItem);

const MenuSection = ({
  section,
  setMenuOpen,
  handleSelectPage,
  handleDisableCurrentToggle = () => {}
}) => {
  const sectionLinks = section.menuItems.map((item, idx) => {
    if (item.onClick) {
      const { stayOpen = false } = item;
      return (
        <MenuItemWithSounds
          key={idx}
          onClick={() => {
            if (stayOpen) handleDisableCurrentToggle();
            setMenuOpen(stayOpen);
            item.onClick();
          }}
        >
          <span className={item.name.replace(' ', '-')}>{item.name}</span>
        </MenuItemWithSounds>
      );
    } else
      return (
        <LinkContainer
          key={idx}
          to={{
            pathname: item.pathName,
            state: { initiator: 'main-menu-item' }
          }}
          activeClassName=""
          onClick={() => {
            handleSelectPage(item);
          }}
        >
          <MenuItemWithSounds>
            <span className={item.name.replace(' ', '-')}>{item.name}</span>
          </MenuItemWithSounds>
        </LinkContainer>
      );
  });
  return (
    <div className="menu-section">
      <h2 className="section-header">{section.header}</h2>
      <div className="section-links">{sectionLinks}</div>
    </div>
  );
};

export const MainMenuItems = ({
  user,
  startSiteTour,
  toggleSocialFeed,
  onMenuToggle,
  isMobileScreen,
  toggleCasinoSounds,
  casinoSoundsOn,
  onIgnoreNextToggle,
  onIgnoreCurrentToggle
}) => {
  const PLAY_AND_EARN = {
    header: 'Play & Earn',
    menuItems: [
      { name: 'Games', pathName: '/slots' },
      { name: 'Tournaments', pathName: '/tournaments' },
      { name: 'Auctions', pathName: '/auctions' },
      { name: 'Drawings', pathName: '/drawings' },
      { name: 'Quests', pathName: '/quests' },
      { name: 'My Vault', pathName: '/vault' }
    ]
  };

  const SHOP_AND_REDEEM = {
    header: 'Shop & Redeem',
    menuItems: [
      { name: 'WStore', pathName: '/wstore' },
      { name: 'My Rewards', pathName: '/rewards' },
      { name: 'Prize Code Redemption', pathName: '/prizecoderedemption' }
    ]
  };

  const PROMOS = {
    header: 'Promos',
    menuItems: [
      { name: 'Promo Perks', pathName: '/promo-perks' },
      { name: 'Double Drive', pathName: '/double-drive' },
      { name: 'Videos', pathName: '/videos' },
      { name: 'Get The Casinoverse Mobile App', pathName: '/about-casinoverse' }
    ]
  };

  const WC_LOCATIONS = {
    header: 'Wind Creek Locations',
    menuItems: [
      { name: 'Hotel Booking', pathName: '/hotel-booking' },
      { name: 'Calendar', pathName: '/calendar' },
      { name: 'Game Finder', pathName: '/game-finder' }
    ]
  };

  const andMoreMenuItems = [
    { name: 'My Profile', pathName: '/profile' },
    {
      name: `Casino Sound ${casinoSoundsOn ? 'On' : 'Off'}`,
      onClick: toggleCasinoSounds,
      stayOpen: true
    },
    { name: 'Support & FAQs', pathName: '/support' },
    { name: 'Site Tour', onClick: startSiteTour },
    { name: 'Sign Out', pathName: '/logout' }
  ];

  if (isMobileScreen) {
    andMoreMenuItems.unshift({
      name: 'Social Wall',
      pathName: '/'
    });
  }

  const AND_MORE = {
    header: 'And More...',
    menuItems: andMoreMenuItems
  };

  const handleSelectPage = item => {
    if (item && item.name === 'Social Wall') {
      toggleSocialFeed(true);
    } else {
      toggleSocialFeed(false);
    }
    onIgnoreNextToggle();
    onMenuToggle(false, item.pathName);
  };

  return (
    <div className="main-menu-items-container">
      <div className="main-menu-left-panel">
        <MenuSection
          section={PLAY_AND_EARN}
          setMenuOpen={onMenuToggle}
          handleSelectPage={handleSelectPage}
        />
        <MenuSection
          section={SHOP_AND_REDEEM}
          setMenuOpen={onMenuToggle}
          handleSelectPage={handleSelectPage}
        />
        <HeaderAdminLink user={user} />
      </div>
      <div className="main-menu-intersection"></div>
      <div className="main-menu-right-panel">
        <MenuSection
          section={PROMOS}
          setMenuOpen={onMenuToggle}
          handleSelectPage={handleSelectPage}
        />
        <MenuSection
          section={WC_LOCATIONS}
          setMenuOpen={onMenuToggle}
          handleSelectPage={handleSelectPage}
        />
        <MenuSection
          section={AND_MORE}
          setMenuOpen={onMenuToggle}
          handleSelectPage={handleSelectPage}
          handleDisableCurrentToggle={onIgnoreCurrentToggle}
        />
      </div>
    </div>
  );
};
